import {Cookies} from "../classes/cookies";

const COOKIE_MODAL_SHOWN = 'announcement-modal-shown';

export default class AnnouncementModal {

	static init() {
		return new AnnouncementModal();
	}

	constructor() {
		
		const $modal = $('#announcement-modal');

		$modal.find('a[role="button"]').on('click', () => {
			$modal.modal('hide');
		});
		
		if(Cookies.get(COOKIE_MODAL_SHOWN) !== 'true')
			$modal.modal('show');
		
		$modal.on('hidden.bs.modal', function (e) {
			Cookies.set(COOKIE_MODAL_SHOWN, true, 7);
		});
	}
}